import $ from 'jquery'

const headerId = '#site-header'

/**
 * Elements and the class to add or remove.
 * @type {obj}
 */
const elements = {
  [headerId]: 'is-minimized',
  '.mnu-hdr': 'mnu-hdr-collapse',
}

/**
 * Compose the method.
 * @param action
 * @return {string}
 */
const method = action => `${action}Class`

/**
 * Reach into the DOM and mutate the elements.
 * @param action
 * @return {void}
 */
const mutate = action => {
  Object.keys(elements).forEach(el => {
    $(el)[method(action)](elements[el])
  })
}

/**
 * Should the header be minimized?
 * @return {boolean}
 */
const shouldMinimize = () => $(window).scrollTop() > 1
  && $(window).width() > 800


/**
 * Add or remove classes on scroll.
 * @return {void}
 */
const onScroll = () => shouldMinimize()
  ? mutate('add')
  : mutate('remove')

export default function () {
  $(document).ready(function() {
    if ($(headerId).hasClass('site-header')) {
      $(window).scroll(onScroll)
    }
  })
}
